/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { Button, SwitchButton, LoadingDocuments } from "../../ui";
import { InputDatePicker, InputFile, InputText } from "../../form";
import {
  CREATE_SEGUIMIENTO,
  UPLOAD_FILE_DOCUMENT,
  CREATE_DOC_REMIDER,
} from "../../../services/siniestro";
import { useDropzone } from "react-dropzone";
import { CloseBlueIcon } from "../../../assets/icons/Icons";

export default function SeguimientoForm({
  contract,
  sinester,
  getAllRemiderByIdSinester,
}) {
  const [allFilesFoll, setAllFilesFoll] = useState([]);
  const [errorFile, setErrorFile] = useState([]);
  const [showSeguimiemto, setShowSeguimiento] = useState(false);
  const [urlFile, setUrlFile] = useState([]);
  const [valueInput, setValueInput] = useState("Ok");

  const [succesData, setSuccesData] = useState(false);
  const [errorDocuments, setErrorDocuments] = useState("");

  // Mutations
  const [createDocRemider] = useMutation(CREATE_DOC_REMIDER);

  const [createSeguimiento, resultsCreateFollow] = useMutation(
    CREATE_SEGUIMIENTO,
    {
      onCompleted({ createSeguimiento }) {
        if (createSeguimiento.statusCode === 200) {
          const result = JSON.parse(createSeguimiento.response);
          getAllRemiderByIdSinester({
            variables: { idSinester: result.siniestro_id },
          });
          if (allFilesFoll.length > 0) {
            for (let i = 0; i < allFilesFoll.length; i++) {
              const docRemiderInput = {
                input: {
                  url: urlFile[i].url.Location,
                  recordatorio_id: result.recordatorio_id,
                  nombre_archivo: urlFile[i].fileName,
                },
              };
              createDocRemider({
                variables: docRemiderInput,
              });
            }
          }
        }
      },
      onError(err) {
        console.log("Error: ", err);
      },
    }
  );

  const [uploadDocuments, { loading: loadingDocuments }] = useMutation(
    UPLOAD_FILE_DOCUMENT,
    {
      fetchPolicy: "no-cache",
      onCompleted({ uploadDocuments }) {
        if (uploadDocuments.statusCode === 200) {
          const urlDocument = JSON.parse(uploadDocuments.response);
          setUrlFile((data) => [...data, urlDocument]);
        }
        if (uploadDocuments.statusCode === 400) {
          setErrorDocuments(uploadDocuments.error);
        }
      },
      onError(err) {
        console.log("Error: ", err);
        setErrorDocuments("Error al subir archivo");
        setErrorFile(err);
      },
    }
  );

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  const onDrop = (acceptedFiles) => {
    const newAcceptedFiles = acceptedFiles;
    if (newAcceptedFiles.length > 1) {
      for (let i = 0; i < newAcceptedFiles.length; i++) {
        setAllFilesFoll((data) => [...data, [newAcceptedFiles[i]]]);
      }
      return;
    }
    let valueInputTwo = acceptedFiles;
    if (valueInputTwo !== undefined) {
      setAllFilesFoll((data) => [...data, valueInputTwo]);
    }
  };

  const handleUploadMutation = async () => {
    for (const [i, dataArr] of allFilesFoll.entries()) {
      try {
        await uploadDocuments({
          variables: {
            fileDocument: [dataArr[0]],
            fileSize: dataArr[0].size,
          },
        });
      } catch (error) {
        console.log(`Error al subir el archivo ${dataArr[0].path}:`, error);
        setErrorDocuments(`Error al subir el archivo ${dataArr[0].path}`);
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  const onSubmit = async (data) => {
    if (sinester.length > 0 && showSeguimiemto) {
      if (allFilesFoll.length > 0) {
        await handleUploadMutation();
      }
      const seguimientoInput = {
        input: {
          nota: data.notasSeguimiento,
          fecha: `${data.fechaSeguimiento}`,
          siniestro_id: sinester[0].siniestro_id,
          fechaContract: contract.fecha_fin,
        },
      };
      await createSeguimiento({
        variables: seguimientoInput,
      });
    }
    reset({
      fechaSeguimiento: null,
      notasSeguimiento: "",
    });
    setSuccesData(true);
    setUrlFile([]);
    setAllFilesFoll([]);
  };

  // Función eliminar documento
  const removeFileSeg = (index) => () => {
    const updatedFiles = [...allFilesFoll];

    updatedFiles.splice(updatedFiles.indexOf(index), 1);

    setAllFilesFoll(updatedFiles);
  };

  return (
    <>
      <LoadingDocuments
        loadingDocuments={loadingDocuments}
        succesData={succesData}
        setSuccesData={setSuccesData}
        errorDocuments={errorDocuments}
        setErrorDocuments={setErrorDocuments}
      />
      <SubModuleContainer>
        <ModuleTitle style={{ color: "var(--primary-royal-blue)" }}>
          Programar seguimiento
        </ModuleTitle>
        {true && <SwitchButton setShowSeguimiento={setShowSeguimiento} />}
      </SubModuleContainer>
      <form onSubmit={handleSubmit(onSubmit)}>
        <SeguimientoContent show={showSeguimiemto}>
          <InputText
            label="Notas de seguimiento"
            name="notasSeguimiento"
            type="text"
            control={control}
            placeholder="Notas"
            register={{ ...register("notasSeguimiento") }}
            errorMessage={errors.notasSeguimiento?.type}
            required={true}
            // readOnly={siniestroId !== ""}
          />
          <div style={{ height: "12px" }} />
          <GridContainer>
            <InputDatePicker
              label="Fecha de seguimiento"
              control={control}
              name="fechaSeguimiento"
              errorMessage={errors.fechaSeguimiento?.type}
              required={true}
              // readOnly={siniestroId !== ""}
            />
            <div>
              <div {...getRootProps()}>
                <InputFile
                  inputProps={getInputProps()}
                  label="Anexos documentales"
                  placeholder="Documentales"
                  idInput={"inputUploadSeguimiento"}
                />
              </div>
              <DocsContainer>
                {allFilesFoll.map((item, i) => (
                  <div key={i}>
                    {item.map((file, index) => (
                      <DocButton key={index}>
                        <CloseBlueIcon onClick={removeFileSeg(index)} />
                        <p className="overflow-ellipsis">{file?.path}</p>
                      </DocButton>
                    ))}
                  </div>
                ))}
              </DocsContainer>
            </div>
          </GridContainer>
        </SeguimientoContent>
        <ButtonContainer>
          <Button
            text={"Guardar"}
            type="submit"
            readOnly={!showSeguimiemto}
            style={{ padding: "8px 24px", fontSize: "14px" }}
          />
        </ButtonContainer>
      </form>
    </>
  );
}

const GridContainer = styled.div`
  display: grid;
  justify-content: space-between;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 12px;
  column-gap: 32px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const SeguimientoContent = styled.div`
  display: ${({ show }) => (show ? "block" : "none")};
`;

const SubModuleContainer = styled.div`
  padding: 20px 0;
  display: flex;
  gap: 30px;
  align-items: center;
`;
const DocsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
`;

const DocButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 14px 4px 4px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  text-decoration: underline;
  font-weight: 600;
  & svg {
    width: 22px;
    height: 22px;
  }
  &:hover {
    opacity: 0.8;
  }
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  p {
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
  }
`;
